import { render, staticRenderFns } from "./PremiumSelect.vue?vue&type=template&id=67ed11a8&scoped=true"
import script from "./PremiumSelect.vue?vue&type=script&lang=js"
export * from "./PremiumSelect.vue?vue&type=script&lang=js"
import style0 from "./PremiumSelect.vue?vue&type=style&index=0&id=67ed11a8&prod&scoped=true&lang=css"
import style1 from "./PremiumSelect.vue?vue&type=style&index=1&id=67ed11a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ed11a8",
  null
  
)

export default component.exports